import type { SVGProps } from 'react';
const SvgGameCam = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 26 26"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.75 3.938c0 .519.418.937.938.937h10.625c.519 0 .937-.418.937-.937A.935.935 0 0 0 18.313 3H7.688a.935.935 0 0 0-.938.938m-1.875 3.75c0 .519.418.937.938.937h14.375c.519 0 .937-.418.937-.937a.935.935 0 0 0-.937-.938H5.813a.935.935 0 0 0-.938.938M20.5 12.375c.344 0 .625.281.625.625v7.5a.627.627 0 0 1-.625.625h-15a.627.627 0 0 1-.625-.625V13c0-.344.281-.625.625-.625zM5.5 10.5A2.5 2.5 0 0 0 3 13v7.5C3 21.879 4.121 23 5.5 23h15c1.379 0 2.5-1.121 2.5-2.5V13c0-1.379-1.121-2.5-2.5-2.5zm1.875 5.625a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5M15.5 14.25a.94.94 0 0 0-.75.375l-1.594 2.125-.656-.875a.938.938 0 0 0-1.5 0l-1.875 2.5a.938.938 0 0 0 .75 1.5h8.438a.937.937 0 0 0 .75-1.5l-2.813-3.75a.94.94 0 0 0-.75-.375"
    />
  </svg>
);
export default SvgGameCam;
